<template>
  <div>
    <div class="report" id="report">
      <!--      <webview-->
      <!--        v-if="webview"-->
      <!--        class="report-wv"-->
      <!--        :style="`height:${dispH - 280}px`"-->
      <!--        :src="`file://${reportHtmlPath}`"-->
      <!--        ref="reportMw"-->
      <!--        @dom-ready="domReady"-->
      <!--        @did-finish-load="printReport"-->
      <!--      ></webview>-->
    </div>
  </div>
</template>

<script>
import fileSys from "../../../fileoprators/fileSystem";
import Dicom from "../../../mainInterface/js/dicom/Dicom";
import {
  getFullName,
  getSystemTime,
  isDefined,
  isFunction,
  jsGetAge,
  objectCopy
} from "../../../shared/utils";
import { Message, Size } from "../../../mixins";
import { formatDate, paramNormal } from "../../../shared/filters";
import { mapGetters } from "vuex";
import GenReportMap from "../../../topography/js/GenReportMap";
import {
  isDataValid,
  MAPSTYLES,
  isPointInCircle,
  cartesian2polar,
  FLATCOLOR,
  STEEPCOLOR
} from "../../../topography/shared";
import EVENTS from "../../../bus";

import { MAJMEDIANMODES } from "../../../topography/shared/consts";
let ejs = window.require("ejs");
let dicom = new Dicom();
// let timeout
let timeoutWait;
let values = new Array(66);
values.fill(-1000);
let genReportMap;
const KEY = "pupilcorneadia";
export default {
  name: "Report",
  data() {
    return {
      webview: false,
      reportHtmlPath: "",
      pdfPath: fileSys.getTopoGrahyReportFilePath(`topographyreport.pdf`),
      paramValues: [],
      greensrc: require("../../../assets/img/green.jpg"),
      yellowsrc: require("../../../assets/img/yellow.jpg"),
      fourMap: {}
    };
  },
  props: [
    "patient",
    "checkDate",
    "currentEye",
    "record",
    "mapValues",
    "exportFilesPath",
    "startShowReport",
    "casePath",
    "hasTopographyReport"
  ],
  mixins: [Message, Size],
  computed: {
    ...mapGetters(["dateFormat", "zernikeViewParams", "dataShowSettings", "mapDrawSettings"]),
    RhRfTitle() {
      return this.dataShowSettings.isRhRv ? "Rh" : "Rf";
    },
    RvRsTitle() {
      return this.dataShowSettings.isRhRv ? "Rv" : "Rs";
    },
    eccPEQTitle() {
      let title = "ecc";
      let mode = this.dataShowSettings.medianMode;
      switch (mode) {
        case MAJMEDIANMODES.ecc:
          title = `ecc(${this.dataShowSettings.mm}mm):`;
          break;
        case MAJMEDIANMODES.E:
          title = `E(${this.dataShowSettings.mm}mm):`;
          break;
        case MAJMEDIANMODES.P:
          title = `P(${this.dataShowSettings.mm}mm):`;
          break;
        case MAJMEDIANMODES.Q:
          title = `Q(${this.dataShowSettings.mm}mm):`;
          break;
        default:
          break;
      }
      return title;
    }
  },
  methods: {
    domReady() {
      this.$refs.reportMw.setZoomLevel(1.8);
    },
    getRhRf(params) {
      return paramNormal(this.dataShowSettings.isRhRv ? params["Rh"].value : params["Rf"].value);
    },
    getRvRs(params) {
      return paramNormal(this.dataShowSettings.isRhRv ? params["Rv"].value : params["Rs"].value);
    },
    getCartesianPolar(params, keyX, keyY) {
      if (this.dataShowSettings.isCartesian) {
        return `${paramNormal(params[keyX].value)}mm, ${paramNormal(params[keyY].value)}mm`;
      } else {
        if (isDataValid(params[keyX].value) && isDataValid(params[keyY].value)) {
          let { dist, angle } = cartesian2polar(params[keyX].value, params[keyY].value);
          return `${paramNormal(dist)}mm @ ${paramNormal(angle, { fixed: 0, rpText: "--" })}°`;
        } else {
          return `--mm @ --°`;
        }
      }
    },
    normalParamsData(params) {
      if (!isDefined(params)) return [];
      let paramValues = [];
      let obj = {
        label: `K1 / ${this.RhRfTitle}:`,
        value: `${paramNormal(params["K1"].value)}D @ ${paramNormal(params["AxisFlat"].value)}° / ${this.getRhRf(params)}mm`,
        color: FLATCOLOR
      };
      paramValues.push(obj);
      obj = {
        label: `K2 / ${this.RvRsTitle}:`,
        value: `${paramNormal(params["K2"].value)}D @ ${paramNormal(params["AxisSteep"].value)}° / ${this.getRvRs(params)} mm`,
        color: STEEPCOLOR
      };
      paramValues.push(obj);
      obj = {
        label: `Km / Rm:`,
        value: `${paramNormal(params["Km"].value)}D / ${paramNormal(params["Rm"].value)}mm`
      };
      paramValues.push(obj);
      let astig = -1000;
      let axis = -1000;
      if (isDataValid(params["K1"].value) && isDataValid(params["K2"].value)) {
        astig = params["K1"].value - params["K2"].value;
      }
      if (isDataValid(params["AxisFlat"].value) && isDataValid(params["AxisSteep"].value)) {
        axis = params["AxisFlat"].value;
      }
      obj = {
        label: `Astig:`,
        value: `${paramNormal(astig)}D / ${paramNormal(axis)}°`
      };
      paramValues.push(obj);
      obj = {
        label: this.eccPEQTitle,
        value: `${paramNormal(params["EccPEQ"].value)}`
      };
      paramValues.push(obj);
      obj = {
        label: "Kmax / Rmin:",
        value: `${paramNormal(params["Kmax"].value)}D / ${paramNormal(params["Rmin"].value)}mm (${this.getCartesianPolar(params, "RminX", "RminY")})`,
        isLong: true
      };
      paramValues.push(obj);
      return paramValues;
    },
    webviewLoaded(ev) {
      this.$bus.$emit(EVENTS.hideGlobalWatting);
    },
    clearWaitTimeOut() {
      clearTimeout(timeoutWait);
      timeoutWait = setTimeout(() => {
        this.$bus.$emit(EVENTS.hideGlobalWatting);
      }, 10000);
    },
    // 制作ejs
    async renderEjs(url, renderobj, callback) {
      try {
        return await ejs.renderFile(url, renderobj);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async createReportHtml() {
      this.clearWaitTimeOut();
      let data = this.normalReportData();
      let fourmapHtml = "";
      let zernikeHtml = "";
      let pupilcorneaHtml = "";
      try {
        if (!fileSys.deleteFile(fileSys.getTopoGrahyReportFilePath("topographyreport.html"))) {
          throw new Error("delete html file error");
        }
        if (isDefined(data)) {
          this.fourMap = data.fourMaps;
          let headerHtml = await this.renderEjs(
            fileSys.getTopoGrahyReportFilePath("header.ejs"),
            data
          );
          let footerHtml = await this.renderEjs(
            fileSys.getTopoGrahyReportFilePath("footer.ejs"),
            data
          );
          let html = await this.renderEjs(fileSys.getTopoGrahyReportFilePath("index.ejs"), data);
          if (data.printFlags.FourMaps) {
            let paramsHtml = await this.renderEjs(
              fileSys.getTopoGrahyReportFilePath("params.ejs"),
              data
            );
            fourmapHtml = await this.renderEjs(
              fileSys.getTopoGrahyReportFilePath("fourmaps.ejs"),
              data
            );
            fourmapHtml = fourmapHtml
              .replace("____header____", headerHtml)
              .replace("____params____", paramsHtml)
              .replace("____footer____", footerHtml);
          }
          if (data.printFlags.Zernike) {
            zernikeHtml = await this.renderEjs(
              fileSys.getTopoGrahyReportFilePath("abberation.ejs"),
              data
            );
            zernikeHtml = zernikeHtml
              .replace("____header____", headerHtml)
              .replace("____footer____", footerHtml);
          }
          if (data.printFlags.PupilCornea) {
            data.backgrounds = { green: this.greensrc, yellow: this.yellowsrc };
            pupilcorneaHtml = await this.renderEjs(
              fileSys.getTopoGrahyReportFilePath("pupilcornea.ejs"),
              data
            );
            pupilcorneaHtml = pupilcorneaHtml
              .replace("____header____", headerHtml)
              .replace("____footer____", footerHtml);
          }
          html = html.replace("____fourmaps____", fourmapHtml);
          html = html.replace("____zernike____", zernikeHtml);
          html = html.replace("____pupilcornea____", pupilcorneaHtml);
          fileSys.writeFileSync(fileSys.getTopoGrahyReportFilePath("topographyreport.html"), html);
          this.reportHtmlPath = fileSys.getTopoGrahyReportFilePath("topographyreport.html");
        } else {
          this.reportHtmlPath = fileSys.getTopoGrahyReportFilePath(
            `error.html?failedTxt=${this.$t("langcfg.txtCreateReportFailed")}`
          );
        }
      } catch (e) {
        this.reportHtmlPath = fileSys.getTopoGrahyReportFilePath(
          `error.html?failedTxt=${this.$t("langcfg.txtCreateReportFailed")}`
        );
      } finally {
        this.$bus.$emit(EVENTS.hideGlobalWatting);
      }
    },
    stopPrintReport(callback) {},
    // 打印
    printReport: function () {
      // // this.clearWaitTimeOut()
      // // this.$bus.$emit(EVENTS.showGlobalWatting, undefined, 100)
      // 判断是否有角膜报告
      if (this.hasTopographyReport) {
        const replace = this.checkDate.replace(/\s+/g, "_");
        const replace2 = replace.replace(/[\s:]/g, "-");
        if (this.reportHtmlPath) {
          fileSys.deleteFile(this.pdfPath);
          let _this = this;
          this.$refs.reportMw.getWebContents().printToPDF(
            {
              pageSize: "A4"
            },
            (error, data) => {
              if (error) throw error;
              fileSys.writeFile(_this.exportFilesPath + replace2 + ".pdf", data, (error) => {
                if (error) {
                  throw error;
                } else {
                  const callback = {
                    type: true,
                    fourMap: _this.fourMap
                  };
                  _this.$emit("exportTopographyFinished", callback);
                  _this.webview = false;
                }
              });
            }
          );
        }
      } else {
        const callback = {
          type: true,
          fourMap: this.normalReportDataNoReport()
        };
        this.$emit("exportTopographyFinished", callback);
        this.webview = false;
      }
    },
    isContentValid() {
      return (
        isDefined(this.record) &&
        isDefined(this.record.content) &&
        isDefined(this.record.content[`data${this.currentEye}`]) &&
        isDefined(this.record.content[`data${this.currentEye}`][KEY]) &&
        this.record.content[`data${this.currentEye}`][KEY].diagnosed
      );
    },
    isModeDataValid(mode) {
      return (
        this.isContentValid() && isDefined(this.record.content[`data${this.currentEye}`][KEY][mode])
      );
    },
    initData() {
      let data = {};
      genReportMap = null;
      data.hospitalInfo = objectCopy(window.printSettings.general);
      data.hospitalInfo.logoPath = fileSys.getCfgPath(data.hospitalInfo.hospitallogo);
      data.hospitalInfo.title_topograpy =
        window.printSettings.general.title_topograpy === "Report"
          ? this.$t("langcfg.txtReport")
          : window.printSettings.general.title_topograpy;
      data.printFlags = objectCopy(window.printSettings.topography);
      data.eye = this.currentEye || "--";
      data.langcfg = this.$i18n.messages[this.$i18n.locale].langcfg;
      data.printDate = formatDate(getSystemTime(), this.dateFormat);
      data.params = this.normalParamsData(this.mapValues.params);
      let fourmapsDrawSettings = window.mapDrawSettings.fourmaps;
      data.patientInfo = {
        name: window.__ct__.debug ? "张三" : "",
        pid: window.__ct__.debug ? "000000001" : "",
        sex: window.__ct__.debug ? "男" : "",
        age: window.__ct__.debug ? "29" : "",
        birthday: window.__ct__.debug ? "1988-12-10" : "",
        checkDate: window.__ct__.debug ? "2018-10-10" : ""
      };
      data.fourMaps = {
        sCurvature: {
          cliPath: fourmapsDrawSettings.mapInForm0.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: fourmapsDrawSettings.mapInForm0.shapes.ShowDiameter9mm ? "trans" : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg") : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: ""
        },
        tCurvature: {
          cliPath: fourmapsDrawSettings.mapInForm1.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: fourmapsDrawSettings.mapInForm1.shapes.ShowDiameter9mm ? "trans" : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg") : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: ""
        },
        elevation: {
          cliPath: fourmapsDrawSettings.mapInForm2.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: fourmapsDrawSettings.mapInForm2.shapes.ShowDiameter9mm ? "trans" : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg") : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: ""
        },
        frp: {
          cliPath: fourmapsDrawSettings.mapInForm3.shapes.ShowDiameter9mm
            ? "clip-path9mm"
            : "clip-path",
          trans: fourmapsDrawSettings.mapInForm3.shapes.ShowDiameter9mm ? "trans" : "img-width",
          map: window.__ct__.debug ? fileSys.getMockPath("map.jpg") : "",
          numVals: null,
          minMaxVals: null,
          numValsMap: ""
        }
      };
      data.aberration = {
        params: [],
        svgPath: fileSys.getCfgPath("img/zernikes/"),
        values: values,
        zernikeSet: window.zernikeSet,
        map: window.__ct__.debug ? fileSys.getMockPath("map.jpg") : "",
        maxPeak: { x: "--", y: "--" },
        meanRms: { mean: "--", rms: "--" },
        retinal: {
          image: window.__ct__.debug ? fileSys.getMockPath("E.bmp") : "",
          title: "psf"
        },
        psf: {
          image: window.__ct__.debug ? fileSys.getMockPath("E.bmp") : "",
          title: "psf",
          label: "fdf"
        },
        chart: {
          image: window.__ct__.debug ? fileSys.getMockPath("E.bmp") : "",
          title: "psf"
        }
      };
      data.pupilCornea = {
        cornea: {
          x: "--",
          y: "--",
          r: "--"
        },
        pupil: {
          x: "--",
          y: "--",
          r: "--"
        },
        image: window.__ct__.debug ? fileSys.getMockPath("map.jpg") : "",
        circleImage: ""
      };
      return data;
    },
    drawPupilCenter(edgePupil, edgeCornea, data) {
      let canvas = document.createElement("canvas");
      canvas.width = 2048;
      canvas.height = 1536;
      // draw pupil
      let ctx = canvas.getContext("2d");
      ctx.lineWidth = 4;
      ctx.font = `50px arial`;
      ctx.setLineDash([10, 10]);
      if (edgePupil && isDataValid(edgePupil.r)) {
        ctx.save("translate");
        ctx.translate(edgePupil.x, edgePupil.y);
        ctx.strokeStyle = "#0f0";
        ctx.beginPath();
        ctx.arc(0, 0, edgePupil.r, 0, 2 * Math.PI, true);
        ctx.stroke();

        ctx.lineWidth = 3;
        ctx.setLineDash([6, 5]);
        ctx.beginPath();
        ctx.moveTo(-20, 0);
        ctx.lineTo(20, 0);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(0, -20);
        ctx.lineTo(0, 20);
        ctx.stroke();
        ctx.restore("translate");
      }
      ctx.lineWidth = 4;
      if (edgeCornea && isDataValid(edgeCornea.r)) {
        // draw cornea
        ctx.save("translate");
        ctx.strokeStyle = "yellow";
        ctx.translate(edgeCornea.x, edgeCornea.y);
        ctx.beginPath();
        ctx.arc(0, 0, edgeCornea.r, (20 / 180.0) * Math.PI, (-20 / 180.0) * Math.PI, true);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(
          0,
          0,
          edgeCornea.r,
          (20 / 180.0) * Math.PI + Math.PI,
          (-20 / 180.0) * Math.PI + Math.PI,
          true
        );
        ctx.stroke();
        ctx.lineWidth = 3;
        ctx.setLineDash([6, 5]);
        ctx.beginPath();
        ctx.moveTo(-20, 0);
        ctx.lineTo(20, 0);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(0, -20);
        ctx.lineTo(0, 20);
        ctx.stroke();
        ctx.restore("translate");
      }
      // ctx.fillStyle = '#0f0'
      // let txt = ` X: ${data.pupil.x} , Y: ${data.pupil.y} R: ${data.pupil.r}`
      // ctx.fillText(this.$t('langcfg.txtPupil') + txt, 20, 80)

      // ctx.fillStyle = 'yellow'
      // txt = ` X: ${data.cornea.x} , Y: ${data.cornea.y} R: ${data.cornea.r}`
      // ctx.fillText(this.$t('langcfg.txtCornea') + txt, 20, 180)
      return canvas.toDataURL();
    },
    normalPatientInfo(data) {
      let age = jsGetAge(this.patient.birthday);
      data.patientInfo.name = getFullName(this.patient);
      data.patientInfo.pid = this.patient.pid;
      data.patientInfo.sex =
        this.patient.sex === "M"
          ? this.$t("langcfg.txtMale")
          : this.patient.sex === "F"
            ? this.$t("langcfg.txtFemale")
            : this.patient.sex === "O"
              ? this.$t("langcfg.txtSexOther")
              : this.patient.sex === "U"
                ? this.$t("langcfg.txtSexUnknown")
                : "";
      data.patientInfo.age = age < 0 ? "" : age;
      data.patientInfo.birthday = this.patient.birthday;
      data.patientInfo.checkDate = formatDate(this.checkDate, this.dateFormat);
    },
    normalXYInMap(v, ratio, isY = false) {
      return isY ? -1 * v * ratio : v * ratio;
    },
    normalMinMaxVals(vals) {
      let _points = [];
      if (isDefined(vals)) {
        vals.px.map((item, index) => {
          if (
            isDataValid(item) &&
            isDefined(vals.py) &&
            isDefined(vals.pz) &&
            isDataValid(vals.pz[index])
          ) {
            _points.push({
              x: item,
              y: vals.py[index],
              value: isDataValid(vals.pz[index]) ? vals.pz[index].toFixed(1) : "" // vals.pz[index].toFixed(1)
            });
          }
        });
      }
      return _points;
    },
    calcMaxMinStartPoint(endX, endY, radius, ratio) {
      let angle = Math.atan2(endX, endY);
      let r = radius === 0 ? 1.5 : radius + 1;
      let point = {
        start: {
          x: this.normalXYInMap(radius * Math.cos(Math.PI / 2 - angle), ratio),
          y: this.normalXYInMap(radius * Math.sin(Math.PI / 2 - angle), ratio, true)
        },

        end: {
          x: this.normalXYInMap(r * Math.cos(Math.PI / 2 - angle), ratio),
          y: this.normalXYInMap(r * Math.sin(Math.PI / 2 - angle), ratio, true)
        },
        isHorizon: Math.abs(angle) < Math.PI / 4 || Math.abs(angle) > (Math.PI * 3) / 4
      };
      return point;
    },
    getColor(flag) {
      return flag ? FLATCOLOR : STEEPCOLOR;
    },
    drawMaxMinVals(ctx, points, ratio) {
      ctx.beginPath();
      ctx.lineWidth = 6;
      let innerR = 0;
      let r = 601 / 2.0;
      let size = this.measureText(ctx, "");
      let w = size.width;
      let h = size.height;
      let cnt = 0;
      points.map((item, index) => {
        if (index === 0) {
          innerR = 0;
        } else if (index % 4 === 0) {
          innerR = innerR === 0 ? 1.5 : innerR + 1;
        }
        if (cnt === 4) {
          cnt = 0;
        }
        let point = this.calcMaxMinStartPoint(item.x, item.y, innerR, ratio);
        if (isPointInCircle(point.end.x, point.end.y, r)) {
          ctx.beginPath();
          ctx.lineWidth = 8;
          ctx.strokeStyle = "red";
          ctx.moveTo(point.start.x, point.start.y);
          ctx.lineTo(point.end.x, point.end.y);
          ctx.stroke();
          ctx.beginPath();
          ctx.lineWidth = 6;
          ctx.strokeStyle = this.getColor(cnt < 2);
          ctx.moveTo(point.start.x, point.start.y);
          ctx.lineTo(point.end.x, point.end.y);
          ctx.stroke();
          let text = item.value;
          if (text && text.length > 0) {
            w = this.measureText(ctx, text).width;
            let oy = point.isHorizon ? h + 4 : 0;
            ctx.fillStyle = "black";
            ctx.fillRect(
              (point.start.x + point.end.x) / 2 - w / 2 - 2,
              (point.start.y + point.end.y) / 2 - h - 4 + oy,
              w + 8,
              h + 8
            );
            ctx.fillStyle = this.getColor(cnt < 2);
            ctx.fillText(
              text,
              (point.start.x + point.end.x) / 2 - w / 2,
              (point.start.y + point.end.y) / 2 + oy
            );
          }
        }
        cnt++;
      });
    },

    drawMaxMin(ctx, ratio, values, dia) {
      if (!isDefined(values) || values.length <= 0) return false;
      let size = this.measureText(ctx, "");
      let w = size.width;
      let h = size.height;
      ctx.save("translate");
      ctx.strokeStyle = ctx.fillStyle = "black";
      let r = 601 / 2.0;
      for (let id = 1; id <= dia / 2; id++) {
        if (this.normalXYInMap(id, ratio) < r) {
          ctx.beginPath();
          let i = id + 0.5;
          let text = (i * 2).toString();
          size = this.measureText(ctx, text);
          w = size.width;
          h = size.height;
          let offsetAngle = Math.atan2(h / 2 + 5, this.normalXYInMap(i, ratio));
          ctx.fillText(text, this.normalXYInMap(i, ratio, true) - w / 2, h / 2);
          ctx.fillText(text, this.normalXYInMap(i, ratio) - w / 2, h / 2);
          // 绘制弧
          ctx.beginPath();
          ctx.arc(0, 0, this.normalXYInMap(i, ratio), offsetAngle, Math.PI * 2);
          ctx.stroke();
          ctx.beginPath();
          ctx.arc(0, 0, this.normalXYInMap(i, ratio) - offsetAngle, Math.PI * 2, true);
          ctx.stroke();
        }
      }
      let _values = this.normalMinMaxVals(values);
      this.drawMaxMinVals(ctx, _values, ratio);
      ctx.restore("translate");
      return true;
    },
    normalNumValuesPoints(pointsX, pointsY, pointsZ = null, ratio, fixed = 2) {
      let _points = [];
      let pointsLen = pointsZ.length;
      for (let i = 0; i < pointsLen; i++) {
        if (isDataValid(pointsX[i]) && isDataValid(pointsY[i])) {
          if (!isDefined(pointsZ) || (isDefined(pointsZ) && isDataValid(pointsZ[i]))) {
            _points.push({
              x: this.normalXYInMap(pointsX[i], ratio),
              y: this.normalXYInMap(pointsY[i], ratio, true),
              value: isDefined(pointsZ) ? pointsZ[i].toFixed(fixed) : null
            });
          }
        }
      }
      return _points;
    },
    measureText(ctx, str) {
      let w = ctx.measureText(str).width;
      let h = ctx.measureText("Z").width;
      return {
        width: w,
        height: h
      };
    },
    drawNumVals(ctx, ratio, values, fix) {
      if (!isDefined(values) || values.length <= 0) return false;
      ctx.save("translate");
      ctx.fillStyle = "black";
      let points = this.normalNumValuesPoints(values.px, values.py, values.pz, ratio, fix);
      let size = this.measureText(ctx, "");
      let w = size.width;
      let h = size.height;
      let radius = 601 / 2.0;
      points.map((item, index) => {
        w = this.measureText(ctx, item.value).width;
        if (isPointInCircle(item.x, item.y, radius)) {
          ctx.fillText(item.value, item.x - w / 2.0, item.y + h / 2.0);
        }
      });
      ctx.restore("translate");
      return true;
    },
    renderMapValues(dia = 9, numVals, minMaxVals, mapstyle) {
      let canvas = document.createElement("canvas");
      canvas.width = 601;
      canvas.height = 601;
      canvas.style.width = "601px";
      canvas.style.height = "601px";
      canvas.style.visibility = "hidden";
      let ctx = canvas.getContext("2d");
      let center = canvas.width / 2.0;
      ctx.translate(center, center);
      let fontsize = 20;
      ctx.font = `${fontsize}px arial`;
      let ratio = canvas.width / dia;
      let fix = mapstyle === MAPSTYLES.ElevationF ? 0 : 2;
      let resultNumVals = this.drawNumVals(ctx, ratio, numVals, fix);
      let resultMinMaxVals = this.drawMaxMin(ctx, ratio, minMaxVals, dia);
      if (resultNumVals || resultMinMaxVals) {
        return canvas.toDataURL();
      }
      return "";
    },
    normalFourMaps(data) {
      if (data.printFlags.FourMaps && !window.__ct__.debug) {
        let fourmapsDrawSettings = window.mapDrawSettings.fourmaps;
        let dia = 12;
        if (
          this.record &&
          this.record.content[`data${this.currentEye}`]["topography"] &&
          this.record.content[`data${this.currentEye}`]["topography"].diagnosed
        ) {
          // genReportMap = new GenReportMap(this.$store.state.topography.casePath)
          genReportMap = new GenReportMap(this.casePath);
          let obj = genReportMap.getMap(MAPSTYLES.TCurvatureF, 0);
          data.fourMaps.tCurvature.map = obj.mapURL;
          if (fourmapsDrawSettings.mapInForm0.shapes.ShowNumericValues) {
            data.fourMaps.tCurvature.numVals = obj.numVals;
          }
          if (fourmapsDrawSettings.mapInForm0.shapes.ShowMaxMin) {
            data.fourMaps.tCurvature.minMaxVals = obj.minMaxVals;
          }
          dia = fourmapsDrawSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12;
          data.fourMaps.tCurvature.numValsMap = this.renderMapValues(
            dia,
            data.fourMaps.tCurvature.numVals,
            data.fourMaps.tCurvature.minMaxVals,
            1,
            MAPSTYLES.TCurvatureF
          );

          obj = genReportMap.getMap(MAPSTYLES.SCurvatureF, 1);
          data.fourMaps.sCurvature.map = obj.mapURL;
          if (fourmapsDrawSettings.mapInForm1.shapes.ShowNumericValues) {
            data.fourMaps.sCurvature.numVals = obj.numVals;
          }
          if (fourmapsDrawSettings.mapInForm1.shapes.ShowMaxMin) {
            data.fourMaps.sCurvature.minMaxVals = obj.minMaxVals;
          }
          dia = fourmapsDrawSettings.mapInForm1.shapes.ShowDiameter9mm ? 9 : 12;
          data.fourMaps.sCurvature.numValsMap = this.renderMapValues(
            dia,
            data.fourMaps.sCurvature.numVals,
            data.fourMaps.sCurvature.minMaxVals,
            0,
            MAPSTYLES.SCurvatureF
          );

          obj = genReportMap.getMap(MAPSTYLES.ElevationF, 2);
          data.fourMaps.elevation.map = obj.mapURL;
          if (fourmapsDrawSettings.mapInForm2.shapes.ShowNumericValues) {
            data.fourMaps.elevation.numVals = obj.numVals;
          }
          if (fourmapsDrawSettings.mapInForm2.shapes.ShowMaxMin) {
            data.fourMaps.elevation.minMaxVals = obj.minMaxVals;
          }
          dia = fourmapsDrawSettings.mapInForm2.shapes.ShowDiameter9mm ? 9 : 12;
          data.fourMaps.elevation.numValsMap = this.renderMapValues(
            dia,
            data.fourMaps.elevation.numVals,
            data.fourMaps.elevation.minMaxVals,
            2,
            MAPSTYLES.ElevationF
          );

          obj = genReportMap.getMap(MAPSTYLES.FRP, 3);
          data.fourMaps.frp.map = obj.mapURL;
          if (fourmapsDrawSettings.mapInForm3.shapes.ShowNumericValues) {
            data.fourMaps.frp.numVals = obj.numVals;
          }
          if (fourmapsDrawSettings.mapInForm3.shapes.ShowMaxMin) {
            data.fourMaps.frp.minMaxVals = obj.minMaxVals;
          }
          dia = fourmapsDrawSettings.mapInForm3.shapes.ShowDiameter9mm ? 9 : 12;
          data.fourMaps.frp.numValsMap = this.renderMapValues(
            dia,
            data.fourMaps.frp.numVals,
            data.fourMaps.frp.minMaxVals,
            3,
            MAPSTYLES.FRP
          );
        } else {
          data.printFlags.FourMaps = false;
        }
      }
    },
    normalZernike(data) {
      let maxPeak = { x: "--", y: "--" };
      let meanRms = { mean: "--", rms: "--" };
      if (data.printFlags.Zernike && !window.__ct__.debug) {
        if (
          this.record &&
          this.record.content[`data${this.currentEye}`]["topography"] &&
          this.record.content[`data${this.currentEye}`]["topography"].diagnosed
        ) {
          // if (!isDefined(genReportMap)) genReportMap = new GenReportMap(this.$store.state.topography.casePath)
          if (!isDefined(genReportMap)) genReportMap = new GenReportMap(this.casePath);
          let result = genReportMap.getZernikeImgs();
          if (isDefined(result)) {
            if (isDefined(result.values)) {
              for (let id = 0; id < result.values.length; id++) {
                if (isDataValid(result.values[id])) {
                  result.values[id] *= 1000;
                }
              }
            }
            if (isDefined(result.maxPeak)) {
              maxPeak.x = isDataValid(result.maxPeak.x) ? result.maxPeak.x.toFixed(2) : "--";
              maxPeak.y = isDataValid(result.maxPeak.y) ? result.maxPeak.y.toFixed(2) : "--";
            }
            if (isDefined(result.meanRms)) {
              meanRms.mean = isDataValid(result.meanRms.mean)
                ? result.meanRms.mean.toFixed(2)
                : "--";
              meanRms.rms = isDataValid(result.meanRms.rms) ? result.meanRms.rms.toFixed(2) : "--";
            }
          }
          data.aberration = {
            params: window.zernikeParams.params,
            svgPath: fileSys.getCfgPath("img/zernikes/"),
            values: isDefined(result) && isDefined(result.values) ? result.values : values,
            zernikeSet: window.zernikeSet,
            map: isDefined(result) ? result.mapURL : "",
            maxPeak: maxPeak,
            meanRms: meanRms,
            retinal: {
              image: isDefined(result) && isDefined(result.retinal) ? result.retinal.URL : "",
              title: isDefined(result) && isDefined(result.retinal) ? result.retinal.title : ""
            },
            psf: {
              image: isDefined(result) && isDefined(result.psf) ? result.psf.URL : "",
              title: isDefined(result) && isDefined(result.psf) ? result.psf.title : "",
              label: isDefined(result) && isDefined(result.psf) ? result.psf.label : ""
            },
            chart: {
              image: isDefined(result) && isDefined(result.chart) ? result.chart.URL : "",
              title: isDefined(result) && isDefined(result.chart) ? result.chart.title : ""
            }
          };
        } else {
          data.printFlags.Zernike = false;
        }
      }
    },
    normalPupilCornea(data) {
      let isValid = this.isContentValid();
      if (data.printFlags.PupilCornea && isValid) {
        let coe = window.magecoe.pupilcornea;
        let edgePupil, edgeCornea;
        let _edge;
        let _edgeMoved;
        if (this.isModeDataValid("corneadia")) {
          _edge = this.record.content[`data${this.currentEye}`][KEY]["corneadia"].edge;
          _edgeMoved = this.record.content[`data${this.currentEye}`][KEY]["corneadia"].edgeMoved;
          edgeCornea = isDataValid(_edgeMoved.r) ? _edgeMoved : _edge;
          data.pupilCornea.cornea.x =
            isDefined(edgeCornea) && isDataValid(edgeCornea.r)
              ? (edgeCornea.x * coe).toFixed(2) + " mm,"
              : "--,";
          data.pupilCornea.cornea.y =
            isDefined(edgeCornea) && isDataValid(edgeCornea.y)
              ? (edgeCornea.y * coe).toFixed(2) + " mm,"
              : "--,";
          data.pupilCornea.cornea.r =
            isDefined(edgeCornea) && isDataValid(edgeCornea.r)
              ? (edgeCornea.r * coe * 2).toFixed(2) + " mm"
              : "--";
        } else {
          data.pupilCornea.cornea = {
            x: "--",
            y: "--",
            r: "--"
          };
        }
        if (this.isModeDataValid("pupildia")) {
          _edge = this.record.content[`data${this.currentEye}`][KEY]["pupildia"].edge;
          _edgeMoved = this.record.content[`data${this.currentEye}`][KEY]["pupildia"].edgeMoved;
          edgePupil = isDataValid(_edgeMoved.r) ? _edgeMoved : _edge;
          data.pupilCornea.pupil.x =
            isDefined(edgePupil) && isDataValid(edgePupil.r)
              ? (edgePupil.x * coe).toFixed(2) + " mm, "
              : "--,";
          data.pupilCornea.pupil.y =
            isDefined(edgePupil) && isDataValid(edgePupil.r)
              ? (edgePupil.y * coe).toFixed(2) + " mm, "
              : "--,";
          data.pupilCornea.pupil.r =
            isDefined(edgePupil) && isDataValid(edgePupil.r)
              ? (edgePupil.r * coe * 2).toFixed(2) + " mm"
              : "--";
        }
        if (this.isModeDataValid("photos")) {
          let img = this.drawPupilCenter(edgePupil, edgeCornea, data.pupilCornea);
          let photos = this.record.content[`data${this.currentEye}`][KEY]["photos"];
          let photo = photos[0];
          const { serverip, serverport, sslport, serverssl } = window.server || {};
          let protocol = serverssl === 1 ? "https:" : "http:";
          let port = serverssl === 1 ? sslport : serverport;
          data.pupilCornea.image = isDefined(photo)
            ? `${protocol}//${serverip}:${port}/media/${photo.filename}?access_token=${window.token}`
            : "";
          data.pupilCornea.circleImage = img;
        } else {
          data.printFlags.PupilCornea = false;
        }
      } else {
        data.printFlags.PupilCornea = false;
      }
    },
    normalReportData() {
      let data;
      try {
        data = this.initData();
        this.normalPatientInfo(data);
        this.normalFourMaps(data);
        this.normalZernike(data);
        this.normalPupilCornea(data);
        return data;
      } catch (e) {
        data = "";
        return data;
      }
    },
    // 111没有报告获取四联图
    normalReportDataNoReport() {
      let data;
      try {
        data = this.initData();
        this.normalFourMaps(data);
        this.normalPupilCornea(data);
        return data;
      } catch (e) {
        data = "";
        return data;
      }
    },
    start() {
      // this.$bus.$emit(EVENTS.showGlobalWatting, undefined, 10)
      dicom.on("dicom-ok", () => {
        this.notify(this.$t("langcfg.txtUploadPdfSuccess"), "", "success");
      });
      dicom.on("dicom-failed", () => {
        this.notify(this.$t("langcfg.txtUploadPdfFailed"), "", "error");
      });

      // 直接导出
      this.clearWaitTimeOut();
      if (this.hasTopographyReport) {
        this.createReportHtml();
      } else {
        this.printReport();
      }
    }
  },
  mounted() {},
  watch: {
    startShowReport(newVal) {
      let _this = this;
      if (newVal) {
        _this.start();
        this.webview = true;
      }
    }
  },
  beforeDestroy() {
    dicom.removeAllListeners();
  }
};
</script>

<style lang="less" scoped>
.el-button {
  border: 1px solid gray;
  padding: 10px;
  width: 90mm;
  height: 70px;
}
//.report {
//  width: 100%;
//  background-color: @page-background;
//  padding-bottom: 100px;
//}
.report {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: absolute;
  top: 0;
  z-index: 10;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  color: #1b1b1b;
}

.report-wv {
  padding-top: 10px;
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: auto;
  resize: none;
  margin: 0 auto;
  //width: 300mm;
  height: 100mm;
  width: 200mm;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/exportUserList/topographyReport.vue